import { Component } from '@angular/core'
import { BaseCellComponent } from './base-cell.component'

@Component({
  selector: 'service-point-cell',
  styles: `
        :host {
            position: relative;
        }
    `,
  template: ' {{ params.data?.[\'service_point_id\'] ?? \'Unknown\' }} ',
})
export class ServicePointCellComponent<
  DATA extends Record<string, unknown>,
> extends BaseCellComponent<
    DATA,
    unknown,
    keyof DATA
  > {}
